function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJfyIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    style: {
      fill: "#5087a0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.57,21.9a11,11,0,1,0,9,9A11.06,11.06,0,0,0,51.57,21.9Z",
    style: {
      fill: "#fff",
      stroke: "#5087a0",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.64,47.07H56.76A12.42,12.42,0,0,1,69.18,59.49V72.06a0,0,0,0,1,0,0h-39a0,0,0,0,1,0,0V59.49A12.42,12.42,0,0,1,42.64,47.07Z",
    style: {
      fill: "#fff",
      stroke: "#5087a0",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.27 9.46 73.69 26.31 90.54 23.73 86.04 19.23 93.36 11.91 88.09 6.64 80.77 13.96 76.27 9.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.73 9.46 26.31 26.31 9.46 23.73 13.96 19.23 6.64 11.91 11.91 6.64 19.23 13.96 23.73 9.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.73 90.54 26.31 73.69 9.46 76.27 13.96 80.77 6.64 88.09 11.91 93.36 19.23 86.04 23.73 90.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.27 90.54 73.69 73.69 90.54 76.27 86.04 80.77 93.36 88.09 88.09 93.36 80.77 86.04 76.27 90.54",
    style: {
      fill: "#fff"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJfyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/jfy-icon.653d7174.svg";
export { ForwardRef as ReactComponent };